// frontend/src/components/messaging/MessageModal.jsx
import React from 'react';
import Modal from '../common/Modal';
import MessageThread from './MessageThread';

const MessageModal = ({ isOpen, onClose, recipientId, recipientName, recipientType, orderRef }) => {
  try {
    return (
      <Modal
        isOpen={isOpen}
        onClose={onClose}
        title="Messages"
        size="large"
        showCloseButton={false}
      >
        <div className="h-[600px] -m-4">
          <MessageThread 
            onClose={onClose}
            recipientId={recipientId}
            recipientName={recipientName}
            recipientType={recipientType}
            orderRef={orderRef}
          />
        </div>
      </Modal>
    );
  } catch (error) {
    console.error('MessageModal Error:', error);
    return (
      <Modal
        isOpen={isOpen}
        onClose={onClose}
        title="Messages Error"
        size="large"
      >
        <div className="p-4">
          <p className="text-red-600">Error loading messages: {error.message}</p>
        </div>
      </Modal>
    );
  }
};

export default MessageModal;